export const HistoryIcon = () =>{
    return(
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
      >
        <g clipPath="url(#clip0_1654_4665)">
          <path
            d="M10.2917 2.375C6.35707 2.375 3.16666 5.56542 3.16666 9.5H0.791656L3.87124 12.5796L3.92666 12.6904L7.12499 9.5H4.74999C4.74999 6.43625 7.22791 3.95833 10.2917 3.95833C13.3554 3.95833 15.8333 6.43625 15.8333 9.5C15.8333 12.5638 13.3554 15.0417 10.2917 15.0417C8.76374 15.0417 7.37832 14.4163 6.38082 13.4108L5.25666 14.535C6.54707 15.8254 8.32041 16.625 10.2917 16.625C14.2262 16.625 17.4167 13.4346 17.4167 9.5C17.4167 5.56542 14.2262 2.375 10.2917 2.375ZM9.49999 6.33333V10.2917L12.8646 12.2867L13.4742 11.2733L10.6875 9.61875V6.33333H9.49999Z"
            fill="#23BBB8"
          />
        </g>
        <defs>
          <clipPath id="clip0_1654_4665">
            <rect width="19" height="19" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
}